import { useQuery } from '@tanstack/react-query';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { listFocusGroups } from '../api/focusGroup.api';

export const useFocusGroups = () => {
  const workspaceId = useCurrentWorkspaceId();

  return useQuery({
    queryKey: ['focusGroups', workspaceId],
    queryFn: listFocusGroups,
    enabled: !!workspaceId,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
